import errorPages from './error-pages.json'
import tableroSeleccion from './tablero-seleccion.json'
import forgotPassword from './forgot-password.json'
import talentPool from './talent-pool.json'
import curriculum from './curriculum.json'
import dashboard from './dashboard.json'
import ecommerce from './ecommerce.json'
import futureTalents from './future-talents.json'
import adminUser from './admin-user.json'
import homePage from './home-page.json'
import userProfile from './user-profile.json'
import companyProfile from './company-profile.json'
import changePassword from './change-password.json'
import footer from './footer.json'
import statistics from './statistics.json'
import hunter from './hunter.json'
import signUp from './sign-up.json'
import signIn from './sign-in.json'
import avisoPublicacion from './aviso-publicacion.json'
import avisoProductos from './aviso-productos.json'
import avisoPublicacionProductos from './aviso-publicacion-productos.json'
import productos from './productos.json'
import avisos from './avisos.json'
import resumenCuenta from './resumen-cuenta.json'
import bumi from './bumi.json'
import selecta from './selecta.json'
import recomendados from './recomendados.json'
import estadisticasGenerales from './estadisticas-generales.json'
import jobi from './jobi.json'
import cart from './cart.json'
import modalValidacionCuit from './modal-validacion-cuit.json'
import conectaDestaque from './conecta-destaque.json'
import busquedaEnBase from './busqueda-en-base.json'
import terminosYCondiciones from './terminos-y-condiciones.json'
import mensajes from './mensajes.json'

const es = {
  pageTitle: 'Portal para empresas - {{nombreSitio}} {{nombrePais}}',
  CV: 'CV',
  currency: '$',
  errorPages,
  forgotPassword,
  tableroSeleccion,
  talentPool,
  curriculum,
  dashboard,
  ecommerce,
  futureTalents,
  adminUser,
  homePage,
  userProfile,
  companyProfile,
  changePassword,
  footer,
  statistics,
  hunter,
  signUp,
  signIn,
  avisoPublicacion,
  avisoProductos,
  avisoPublicacionProductos,
  productos,
  avisos,
  resumenCuenta,
  bumi,
  selecta,
  recomendados,
  estadisticasGenerales,
  jobi,
  cart,
  modalValidacionCuit,
  conectaDestaque,
  busquedaEnBase,
  terminosYCondiciones,
  mensajes,
}

export default es
